export const SENTRY_CONSENT_UC_ID = "b0hANt-DHB3Q-9";
